module.exports = __webpack_public_path__ + "img/timelapse.897a53c2.svg";